var _circle, _circle2, _path, _circle3, _path2, _circle4, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccountConnections(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2858,
    cy: 9.71429,
    r: 1.71429,
    fill: "current"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8573 15.3333C12.8573 13.4924 14.3497 12 16.1906 12H16.3811C18.2221 12 19.7144 13.4924 19.7144 15.3333C19.7144 15.7015 19.416 16 19.0478 16H13.524C13.1558 16 12.8573 15.7015 12.8573 15.3333Z",
    fill: "current"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.42852,
    cy: 9.71429,
    r: 1.71429,
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.3333C4 13.4924 5.49238 12 7.33333 12H7.52381C9.36476 12 10.8571 13.4924 10.8571 15.3333C10.8571 15.7015 10.5587 16 10.1905 16H4.66667C4.29848 16 4 15.7015 4 15.3333Z",
    fill: "current"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.0002,
    cy: 9.14286,
    r: 2.14286,
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.71436 16.1667C7.71436 13.8655 9.57984 12 11.881 12H12.1191C14.4203 12 16.2858 13.8655 16.2858 16.1667C16.2858 16.6269 15.9127 17 15.4525 17H8.54769C8.08745 17 7.71436 16.6269 7.71436 16.1667Z",
    fill: "current"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountConnections);
export default __webpack_public_path__ + "static/media/account-connections.36a6c047edb05087577c64c70cb2fc05.svg";
export { ForwardRef as ReactComponent };